<template>
<div>
    <form id="msform" name="msform">
    <!-- progressbar -->
    <ul id="progressbar">
      <li class="active">
        <h1> Paso 1</h1><span> Comienzo</span>
      </li>
      <li>
        <h1>Paso 2</h1><span>Origen / Destino</span>
      </li>
      <li>
        <h1>Paso 3</h1><span>Carga</span>
      </li>
      <li><h1>Paso 4</h1><span>Confirmación</span>
      </li>
    </ul>
    <div id="top"></div>
    <!-- fieldsets -->
    <fieldset>
      <h3 class="fs-subtitle">
        Crear Nueva Orden de Compra (OC)
      </h3>
      <div class="modulo-opciones">
        <h2 class="fs-title">
           Operación
        </h2>
        <div class="modulo-opciones-radios">
          <div class="radio-container">
            <input id="dato1-1" name="tp_1" type="radio" value="6" v-model="payload.tp_1">
            <label for="dato1-1"><img class="svg" src="../assets/img/icon/importacion.svg"> <span>Importación</span></label>							
          </div>
          <div class="radio-container">
            <input id="dato1-2" name="tp_1" type="radio" value="13" v-model="payload.tp_1">
            <label for="dato1-2"><img src="../assets/img/icon/subir.svg"> <span>Exportación</span></label>
            
          </div>
          <div class="radio-container">
            <input id="dato1-3" name="tp_1" type="radio" value="20" v-model="payload.tp_1">
            <label for="dato1-3"><img src="../assets/img/icon/intercambio.svg"> <span>Traslado</span></label>
          </div>
        </div>
      </div>
      <div class="modulo-opciones" v-if="payload.tp_1 !== '20'">
        <h2 class="fs-title">
           DISTANCIA
        </h2>
        <div class="modulo-opciones-radios">
          <div class="radio-container">
            <input id="dato2-1" name="tp_2" type="radio" value="7" v-model="payload.tp_2">
            <label for="dato2-1"><img src="../assets/img/icon/internacional.svg"> <span>Nacional</span></label>
          </div>
          <div class="radio-container">
            <input id="dato2-2" name="tp_2" type="radio" value="10" v-model="payload.tp_2">
            <label for="dato2-2"><img src="../assets/img/icon/globo.svg"> <span>Internacional</span></label>
          </div>
        </div>
      </div>
      <div class="modulo-opciones">
        <h2 class="fs-title">
           CARGA
        </h2>
        <div class="modulo-opciones-radios">
          <div class="radio-container">
            <input id="dato3-1" name="tp_3" type="radio" value="8" v-model="payload.tp_3">
            <label for="dato3-1"><img src="../assets/img/icon/carretilla.svg"> <span>Carga Suelta</span></label>
          </div>
          <div class="radio-container">
            <input id="dato3-2" name="tp_3" type="radio" value="9" v-model="payload.tp_3">
            <label for="dato3-2"><img src="../assets/img/icon/grua.svg"> <span>Container</span></label>
          </div>
        </div>
      </div>
      <input class="next action-button" name="next" type="button" value="＋ Agregar Flete" @click="next" />
    </fieldset>
    <fieldset>
      <div>
        <h3 class="fs-subtitle">
          {{ operacion }}
        </h3>
        <div  class="x_content modulo-opciones">
          
          <h2 class="fs-title">
            Origen / Destino
          </h2>
          
          <div class="row" v-if="payload.tp_1 === '13' || payload.tp_1 === '20'">

            <div class="col-md-12">

              <div class='form-inner-container'>

                <div class="form-group">
                  <label for="origin[street]">Dirección De Origen</label>
                    <vue-google-autocomplete
                      ref="origin[street]"
                      id="direccion_origen"
                      classname="form-control icon-origen"
                      placeholder="Ingrese la Dirección de Origen"
                      v-on:placechanged="setOriginAddress"
                      country="ar"
                    />
                </div>

                <div class="form-group comment">
                <label for="origin[comment]">Comentarios adicionales:</label>
                  <textarea class="form-control common_comment" rows="2" id="comment" name="origin[comment]" v-model="payload.fletes[activeFleteIndex].origin.comment"></textarea>
                </div>

              </div>

            </div>

          </div>

          
          <div class="modulo-opciones-radios" v-if="payload.tp_1 === '6' || payload.tp_1 === '13'">
            <div class="radio-container">
              <input id="terminal_portuaria" :name="`${payload.tp_1 === '6' ? 'origin' : 'dest'}[type_address]`" type="radio" value="58" v-model="payload.fletes[activeFleteIndex][`${payload.tp_1 === '6' ? 'origin' : 'dest'}`].type_address">
              <label for="terminal_portuaria"><img src="../assets/img/icon/puerto.svg"> <span>{{ `Terminal Portuaria de ${payload.tp_1 === '6' ? 'Origen' : 'Destino'}` }}</span></label>
            </div>
            <div class="radio-container">
              <input id="deposito_fiscal" :name="`${payload.tp_1 === '6' ? 'origin' : 'dest'}[type_address]`" type="radio" value="59" v-model="payload.fletes[activeFleteIndex][`${payload.tp_1 === '6' ? 'origin' : 'dest'}`].type_address">
              <label for="deposito_fiscal"><img src="../assets/img/icon/carga1.svg"> <span>{{ `Depósito Fiscal de ${payload.tp_1 === '6' ? 'Origen' : 'Destino'}` }}</span></label>
            </div>
            <div class="radio-container">
              <input id="other" :name="`${payload.tp_1 === '6' ? 'origin' : 'dest'}[type_address]`" type="radio" value="other" v-model="payload.fletes[activeFleteIndex][`${payload.tp_1 === '6' ? 'origin' : 'dest'}`].type_address">
              <label for="other"><img src="../assets/img/icon/boxes.svg"> <span>{{ `Otra Dirección de ${payload.tp_1 === '6' ? 'Origen' : 'Destino'}` }}</span></label>
            </div>
          </div>
          
          <div style="clear:both;">

            <div class="row">

              <div class="col-md-12" v-if="payload.fletes[activeFleteIndex][`${payload.tp_1 === '6' ? 'origin' : 'dest'}`].type_address === '58'">
                 
                <div class='form-inner-container'>

                <div class="form-group">
                  <label :for="`${payload.tp_1 === '6' ? 'origin' : 'dest'}[terminal]`">{{ `Terminal de ${payload.tp_1 === '6' ? 'Origen' : 'Destino'}` }}</label>
                  <select 
                    :name="`${payload.tp_1 === '6' ? 'origin' : 'dest'}[terminal]`" 
                    :class="`form-control icon-${payload.tp_1 === '6' ? 'origen' : 'destino'}`"
                    >
                    <option value="1">TERMINAL EXOLGAN</option>
                    <option value="2">TERMINALES RIO DE LA PLATA (TRP)</option>
                    <option value="3">TERMINAL 4 (APM TERMINALS)</option>
                    <option value="4">TERMINAL 5 (BACTSSA)</option>
                    <option value="5">TERMINAL ZARATE</option>
                    <option value="6">PUERTO CAMPANA</option>
                    <option value="7">ZONA FRANCA LA PLATA</option>
                    <option value="8">PUERTO DE ROSARIO</option>
                    <option value="9">PUERTO DE TIGRE</option>
                    <option value="10">PUERTO MAR DEL PLATA</option>
                  </select>                
                </div>

                </div>

              </div>

              <div  class="col-md-12" v-if="payload.fletes[activeFleteIndex][`${payload.tp_1 === '6' ? 'origin' : 'dest'}`].type_address === '59'">

                <div class='form-inner-container'>

                <div class="form-group">
                  <label 
                  :for="`${payload.tp_1 === '6' ? 'origin' : 'dest'}[deposit]`">{{ `Depósito de ${payload.tp_1 === '6' ? 'Origen' : 'Destino'}` }}</label>
                  <select  
                  :name="`${payload.tp_1 === '6' ? 'origin' : 'dest'}[deposit]`" 
                  :class="`form-control icon-${payload.tp_1 === '6' ? 'origen' : 'destino'}`"
                  v-model="payload.fletes[activeFleteIndex][`${payload.tp_1 === '6' ? 'origin' : 'dest'}`].deposit">
                    <option value="11">AMERICAN CARGO</option>
                    <option value="12">CAPITAN CORTES</option>
                    <option value="13">CARESTIBA S.A.</option>
                    <option value="14">CENSER LOGISTICA MUNDIAL</option>
                    <option value="15">COAMTRA</option>
                    <option value="16">CORVALAN DEPOSITO FISCAL</option>
                    <option value="17">DASSA - DEPOSITO AVELLANEDA SUR S.A.</option>
                    <option value="18">DEFIBA</option>
                    <option value="19">DEFIBA SERVICIOS PORTUARIOS S.A.</option>
                    <option value="20">DEFISA</option>
                    <option value="21">DEP. FISCAL GARGANO S.A.</option>
                    <option value="22">DEPOSITO FISCAL LOPRIMO1</option>
                    <option value="23">DEPÓSITO FISCAL PATRÓN</option>
                    <option value="24">DEPOSITO GARAY S.A.</option>
                    <option value="25">DEPOSITOS ADUANEROS</option>
                    <option value="26">DEPOSITOS FISCALES SA</option>
                    <option value="27">ENCYM</option>
                    <option value="28">FERROPORT S.A.</option>
                    <option value="29">GEMEZ BARRACAS</option>
                    <option value="30">GEMEZ S.A.</option>
                    <option value="31">GEN-POL S.A.</option>
                    <option value="32">GRUPO SELSA</option>
                    <option value="33">LOGEXPOR</option>
                    <option value="34">LOGÍSTICA CENTRAL</option>
                    <option value="35">LOINEX SA</option>
                    <option value="36">LOTAX</option>
                    <option value="37">M.DODERO CIA</option>
                    <option value="38">MEGATOM</option>
                    <option value="39">MERCOCARGA</option>
                    <option value="40">MURCHISON</option>
                    <option value="41">PIXEL CO. ( AGROCAMPO)</option>
                    <option value="42">PIXEL CO. (ESSO CARD)</option>
                    <option value="43">PLATESTIBA S.A.</option>
                    <option value="44">S.G.F.ARG. S.A.</option>
                    <option value="45">SADECO S.C.A.</option>
                    <option value="46">SADIAL SRL</option>
                    <option value="47">SAF S.A.</option>
                    <option value="48">SAVE CORP. SRL</option>
                    <option value="49">SEXTANS S.A.</option>
                    <option value="50">SOUTH AMERICAN DOCKS S.A.</option>
                    <option value="51">T.C.O.</option>
                    <option value="52">TEFASA 1</option>
                    <option value="53">TEFASA 2</option>
                    <option value="54">TERBASA</option>
                    <option value="55">TERMINAL 7</option>
                    <option value="56">TERMINAL DE CARGAS ARGENTINA (EZEIZA)</option>
                    <option value="57">TERMINAL PANAMERICANA S.A.</option>
                    <option value="58">TRANSTERMINAL S.A.</option>
                    <option value="59">UNIVERSAL CARGA</option>
                    <option value="60">WARRANT COLLATERAL SERVICE</option>
                    <option value="61">ZARATE PORT S.A.</option>
                    <option value="62">DEPOSITO FISCAL FRIO DOCK</option>
                    <option value="63">DEPOSITO FISCAL BAJO CERO</option>
                    <option value="64">TERMINAL SUR</option>
                    <option value="65">ICB</option>
                    <option value="66">DEPOSITO GAMMA MUJICA</option>
                    <option value="67">DEPOSITO GAMMA LIBERTADOR</option>
                    <option value="68">DEPOSITO ASAS ONE</option>
                  </select>
                </div>

                </div>

              </div>
  
              <div class="col-md-12" v-if="payload.fletes[activeFleteIndex][`${payload.tp_1 === '6' ? 'origin' : 'dest'}`].type_address === 'other'">

                <div class='form-inner-container'>

                  <div class="form-group">
                    <label :for="`${payload.tp_1 === '6' ? 'origin' : 'dest'}[street]`">{{ `Dirección de ${payload.tp_1 === '6' ? 'Origen' : 'Destino'}` }}</label>
                      <vue-google-autocomplete
                        :ref="`${payload.tp_1 === '6' ? 'origin' : 'dest'}[street]`"
                        :id="`direccion_${payload.tp_1 === '6' ? 'origen' : 'destino'}`"
                        :classname="`form-control icon-${payload.tp_1 === '6' ? 'origen' : 'destino'}`"
                        :placeholder="`Ingrese la Dirección de ${payload.tp_1 === '6' ? 'Origen' : 'Destino'}`"
                        v-on:placechanged="setAddress"
                        country="ar"
                      /> 
                  </div>

                  <div class="form-group comment">
                  <label :for="`${payload.tp_1 === '6' ? 'origin' : 'dest'}[comment]`">Comentarios adicionales:</label>
                    <textarea class="form-control common_comment" rows="2" id="comment" :name="`${payload.tp_1 === '6' ? 'origin' : 'dest'}[comment]`"></textarea>
                  </div>

                </div>

              </div>

            </div>

            <div class="row" v-if="payload.tp_1 === '6' || payload.tp_1 === '20'">

              <div class="col-md-12">

                <div class='form-inner-container'>

                  <div class="form-group">
                    <label for="dest[street]">Dirección De Destino</label>
                      <vue-google-autocomplete
                        ref="dest[street]"
                        id="direccion_destino"
                        classname="form-control icon-destino"
                        placeholder="Ingrese la Dirección de Destino"
                        v-on:placechanged="setDestinationAddress"
                        country="ar"
                      />
                  </div>

                  <div class="form-group comment">
                  <label for="dest[comment]">Comentarios adicionales:</label>
                    <textarea class="form-control common_comment" rows="2" id="comment" name="dest[comment]" v-model="payload.fletes[activeFleteIndex].dest.comment"></textarea>
                  </div>

                </div>

              </div>

            </div>

          </div>

          <div class="row">

            <div class="col-md-12" id="mapa">

              <GmapMap
                :center="{lat:clientGeolocation.latitude, lng:clientGeolocation.longitude}"
                :zoom="10"
                map-type-id="terrain"
                style="width: 100%; height: 300px"
              >
              <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.coordinate"
                :image="m.image"
                :clickable="true"
                :draggable="false"
                @click="center=m.position"
              />
              </GmapMap>


            </div>

          </div>

          <div v-if="payload.tp_2 === '10'">

            <div class="x_panel">

              <div class="x_title">

                <h2 class="fs-title">Internacional</h2><br/>

              </div>

              <div class="form-inner-container">
                
                <div class="row">

                  <div class="col-md-4 type_incoterm_id">

                      <div class="form-group">

                        <label for="int[type_incoterm_id]">Incoterm</label>
                          <select name="int[type_incoterm_id]" class="form-control" required="" v-model="payload.fletes[activeFleteIndex].int.type_incoterm_id">
                            <option value="47">DDP</option>
                            <option value="48">DAP</option>
                            <option value="49">DAT</option>
                            <option value="50">CIP</option>
                            <option value="51">CPT</option>
                            <option value="52">CIF</option>
                            <option value="53">CFR</option>
                            <option value="54">FCA</option>
                            <option value="55">FOB</option>
                            <option value="56">FAS</option>
                            <option value="57">EXW</option>
                            </select>
                      </div>
                  </div>

                  <div class="col-md-8 border_crossing">
                      <div class="form-group">
                          <label for="int[border_crossing]">Paso fronterizo</label>
                          <input name="int[border_crossing]" class="form-control" required type="text"  v-model="payload.fletes[activeFleteIndex].int.border_crossing">
                          <div class="help-block with-errors"></div>
                      </div>
                  </div>

              </div>

              <div class="row">

                  <div class="col-md-12 col-sm-12 commodity_type">
                      <div class="form-group">
                          <label for="int[commodity_type]">Tipo de Mercaderia</label>
                          <textarea name="int[commodity_type]" class="form-control" required v-model="payload.fletes[activeFleteIndex].int.commodity_type"></textarea>
                          <div class="help-block with-errors"></div>
                      </div>
                  </div>

              </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      <input class="previous action-button" name="previous" type="button" value="Anterior" @click="prev"> 
      <input class="next action-button" name="next" type="button" value="Siguiente" @click="next">

    </fieldset>
 
    <fieldset>
      <h3 class="fs-subtitle">
        {{ operacion }} 
      </h3>
      <div class="modulo-opciones">
        <h2 class="fs-title">
          CARGUEMOS!
        </h2>
        <!-- Si es Contenedor (tp_3 === 9) -->
        <div class="x_content" v-if="payload.tp_3 === '9'">
  
          <div class="row">

            <div class="col-md-6">
                <div class="form-group">
                  <label for="container[code]">Siglas del contenedor</label>
                  <input 
                    name="container[code]" 
                    class="form-control mask-container" 
                    type="text"
                    v-mask="'AAAA-######-X'"
                    v-model="payload.fletes[activeFleteIndex].container.code"
                  >
                  <div class="help-block with-errors"></div>
                </div>
            </div>

            <div class="col-md-6 type_container_id">
              <div class="form-group">
                <label for="container[type_container_id]">Tipo Contenedor</label>
                <select name="container[type_container_id]" class="form-control" required="" v-model="payload.fletes[activeFleteIndex].container.type_container_id">
                  <option value="">Seleccione...</option>
                  <option value="60">20ST</option>
                  <option value="61">20OT</option>
                  <option value="62">20RF</option>
                  <option value="63">20FR</option>
                  <option value="64">40ST</option>
                  <option value="65">40OT</option>
                  <option value="66">40RF</option>
                  <option value="67">40FR</option>
                  <option value="68">40HC</option>
                  <option value="69">40HR</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">

            <div class="col-md-6 type_cargo_id">
              <div class="form-group">
                  <label for="container[type_cargo_id]">Especificiones de Carga</label>
                  <select name="container[type_cargo_id]" class="form-control" required="" v-model="payload.fletes[activeFleteIndex].container.type_cargo_id">
                    <option value="">Seleccione...</option>
                    <option value="70">IMO</option>
                    <option value="71">GENSET</option>
                    <option value="72">OTROS</option>
                    <option value="83" selected>GENERAL</option>
                  </select>
              </div>
            </div>

            <div class="col-md-6 cargo_other">
              <div class="form-group">
                <label for="container[cargo_other]">Otra Carga</label>
                <input name="container[cargo_other]" class="form-control" type="text" v-model="payload.fletes[activeFleteIndex].container.cargo_other">
                <div class="help-block with-errors"></div>
              </div>
            </div>

          </div>
          <div class="row">

            <div class="col-md-6 weight">
              <div class="form-group">
                <label for="container[weight]">Peso</label>
                <input name="container[weight]" min='0' step='1000' class="form-control looseload_weight" required type="number" v-model="payload.fletes[activeFleteIndex].container.weight">
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-md-6 extra-fields extra-fields-date">
              <div class="form-group">
                <label for="extra_field[retirement_date_container]">Fecha de retiro</label>
              
                    <input type="date" name="extra_field[retirement_date_container]" v-model="payload.fletes[activeFleteIndex].container.retirement_date" class="form-control date-picker" required>
              
              </div>
            </div>

          </div>

          <div>

            <div class="modulo-opciones-radios">
              <div class="checkbox-container">
                <input id="container[is_oversized]" name="container[is_oversized]" type="checkbox" v-model="payload.fletes[activeFleteIndex].container.is_oversized" class="form-control date-picker" required>
                <label for="container[is_oversized]">
                  <img src="../assets/img/icon/truck.svg"> <span>Carga Sobredimensionada</span>
                </label>
              </div>
 
            </div>
 
          </div>
          <div style="clear:both"></div>
          <div class="row">
            <div class="col-md-12 comment">
              <div class="form-group">
                <label for="container[comment]">Observaciones de carga</label>
                <textarea name="container[comment]" rows='5' class="form-control common_comment" type="text"  v-model="payload.fletes[activeFleteIndex].container.comment"></textarea>
                <div class="help-block with-errors"></div>
              </div>
            </div>
          </div>

        </div> 
        <!-- Si es Carga Suelta (tp_3 === 8) * -->
        <div class="x_content" v-if="payload.tp_3 === '8'">

          <div class="row">

            <div class="col-md-6">
              <div class="form-group">
                <label for="looseload[weight]">Peso (Kg)</label>
                <input name="looseload[weight]" min='0' step='1000' class="form-control looseload_weight" required type="number" value=""/>
                <!-- <number-input class="form-control" v-model="looseload" :min="1" :max="10" inline controls></number-input> -->
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="looseload[volume]">Volumen (m3)</label>
                <input name="looseload[volume]" min='0' step='100' class="form-control looseload_volume" type="number" value=""/>
                <div class="help-block with-errors"></div>
              </div>
            </div>
          
          </div>

          <div class="row">
          
            <div class="col-md-6">
                <div class="form-group">
                  <label for="looseload[type_cargo_id]">Especificaciones de Carga</label>
                  <select name="looseload[type_cargo_id]" class="form-control looseload_type_cargo">
                    <option value="73">IMO</option>
                    <option value="74">REFRIGERADO</option>
                    <option value="75">OTROS</option>
                    <option value="82" selected>GENERAL</option>
                  </select>
              </div>
            </div>

            <div class="col-md-6">
              <!-- <div class="form-group">
                  <label for="looseload[cargo_other]">Otra Carga</label>
                  <input name="looseload[cargo_other]" class="form-control" type="text" value=""/>
                  <div class="help-block with-errors"></div>
              </div> -->
    
              <div class="form-group">
                <label for="hour_service">Hora de servicio</label>
                <input name="looseload[hour_service]" class="form-control hour_service" type="time" value=""/>
                <div class="help-block with-errors"></div>
              </div>

            </div>

          </div>

          <div>

            <div class="modulo-opciones-radios">
              <div class="checkbox-container">
                <input id="looseload.is_oversized" name="looseload.is_oversized" type="checkbox">
                <label for="looseload.is_oversized">
                  <img src="../assets/img/icon/truck.svg"> <span>Carga Sobredimensionada</span>
                </label>
              </div>

              <div class="button-container">
                <input id="looseload.add_package" name="looseload.add_package" type="button" @click="looseloadAddPackage">
                <label for="looseload.add_package">
                  <img src="../assets/img/icon/cargo.svg"> <span>Agregar Bulto</span>
                </label>
              </div>

            </div>
            
          </div>
           <div v-if="payload.fletes[activeFleteIndex].looseload.packages.length > 0">
            <div v-for="(pckg, nameId) in payload.fletes[activeFleteIndex].looseload.packages">
              <div class='form-inner-container'>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                        <label :for="`packages[${nameId}][type_package_id]`">Tipo de Bultos</label>
                        <select :name="`packages[${nameId}][type_package_id]`" class="form-control type_package_id" required="" v-model="pckg.type_package_id">
                          <option value="77">Cajas</option>
                          <option value="78">Carretes</option>
                          <option value="79">Bolsas</option>
                          <option value="80">Tambores</option>
                          <option value="81">Otros</option>
                        </select>
                        <div class="help-block with-errors"></div>
                    </div>
                  </div>

                  <div class="col-md-4" v-if="pckg.type_package_id === '81'">
                    <div class="form-group">
                      <label :for="`packages[${nameId}][package_other]`">Otro Tipo</label>
                      <input :name="`packages[${nameId}][package_other]`" class="form-control" type="text" value="" v-model="pckg.package_other"/>
                      <div class="help-block with-errors"></div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label :for="`packages[${nameId}][quantity]`">Cantidad de bultos</label>
                      <input :name="`packages[${nameId}][quantity]`" class="form-control quantity" required type="text" value="" v-model="pckg.quantity"/>
                      <div class="help-block with-errors"></div>
                    </div>
                  </div>

                  <div class="col-xs-3 col-sm-3" style="display: none;">
                    <div class="form-group">
                      <label :for="`packages[${nameId}][id_package]`">ID Bulto</label>
                      <input :name="`packages[${nameId}][id_package]`" class="form-control" type="text" value="" v-model="pckg.id_package"/>
                      <div class="help-block with-errors"></div>
                    </div>
                  </div>

              </div>
              
              <div class="row">
                <div class="col-xs-12 col-sm-12">
                  <div class="form-group">
                    <label :for="`packages[${nameId}][comment]`">Especificaciones generales</label>
                    <textarea :name="`packages[${nameId}][comment]`" rows='2' class="form-control common_comment" required type="text" value="" v-model="pckg.comment"></textarea>
                    <div class="help-block with-errors"></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 comment">
                  <div class="form-group text-right remove">
                    <button 
                      :id="`looseload_package_${nameId}`" 
                      class="btn btn-sm remove-button" 
                      @click="looseloadRemovePackage(nameId)"
                      type="button">Sacar Bulto </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
                      <br/>
            <br/>
        </div>
        </div>
      </div>
       
      <input class="previous action-button" name="previous" type="button" value="Anterior" @click="prev"> 
      <input class="submit action-button" name="next" type="button" value="Siguiente" @click="next">
    </fieldset>

    <fieldset>
      <h3 class="fs-subtitle">
        {{ operacion }}
      </h3>
      <div class="modulo-opciones">
        <h2 class="fs-title">
          Datos Comunes
        </h2>
 
          <div class="x_content">

            <div class="row" style="margin-bottom:20px" id="notificaciones">
              <div class="col-xs-12 col-sm-12 comment">
                <div class="notification notification-error" id="error" role="alert" style="display:none;">Ocurrió un Error procesando el formulario.</div>
		            <div class="notification notification-success" id="exito" role="alert" style="display:none;"></div>
                <!-- <code>{{ JSON.stringify(payload, undefined, 2) }}</code>                -->
              </div>
            </div>

            <div>

              <div class="modulo-opciones-radios">
                <div class="checkbox-container">
                  <input id="has_assurance" name="common[has_assurance]" type="checkbox" v-model="payload.fletes[activeFleteIndex].common.has_assurance">
                  <label for="has_assurance"><img src="../assets/img/icon/shield.svg"> <span>Incluír Seguro</span></label>
                </div>
                <div class="checkbox-container">
                  <input id="has_custody" name="common[has_custody]" type="checkbox" v-model="payload.fletes[activeFleteIndex].common.has_custody">
                  <label for="has_custody"><img src="../assets/img/icon/avatar.svg"> <span>Incluír Custodia</span></label>
                </div>
              </div>

            </div>
            
            <div style="clear:both"></div>
            <div class="row">

              <div class="col-md-6">
                <div class="form-group">
                    <label for="extra_field[retirement_date]">Turno</label>
                    <input type="date" name="extra_field[retirement_date]" class="form-control date" required>
                    <div class="help-block with-errors"></div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                    <label for="extra_field[turn]">Turno</label>
                    <input name="extra_field[turn]" class="form-control hour_service" required type="time" value=""/>
                    <div class="help-block with-errors"></div>
                </div>

            </div>

          </div>
 
            <div class="row" style="margin-bottom:20px">
              <div class="col-xs-12 col-sm-12 files-galleries-input">
                <uploader/>
              </div>
            </div>

            <div class="row" style="margin-bottom:20px">
              <div class="col-xs-12 col-sm-12 comment">
                <div class="form-group">
                  <label for="common[comment]">Comentarios adicionales</label>
                  <textarea name="common[comment]" rows='2' class="form-control common_comment" type="text" value=""></textarea>
                  <div class="help-block with-errors"></div>
                </div>
              </div>
            </div>
 
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="role">Notificar via Email a:</label>
                  <!-- <input type="text" name="common.watchers[]" class="form-control common_email" id="watchers" value="info@kiabit.com" /> -->
                  <br/>
                  <vuetagger
                    :value="email_tags"
                    @change="updateTags"
                    pattern="^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$"
                  ></vuetagger>

                </div>
              </div>
            </div>
          </div>
 
       </div>

      <input class="previous action-button" name="previous" type="button" value="Anterior" @click="prev"> 
      <input class="next action-button" name="next" type="button" value="Confirmar" @click="submit">
    </fieldset>
 
  </form>
</div>    
</template>

<script>
import vSelect from 'vue-select'
import $ from 'jquery'
import axios from 'axios'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import NumberInput from '@chenfengyuan/vue-number-input'
import vuetagger from 'vuetagger'
import {mask} from 'vue-the-mask'
import uploader from './Uploader'
import denominaciones from './Utils/Denominaciones'
// import GoogleAutocomplete from 'google-autocomplete-vue'

window.$ = window.jQuery = $
export default {
  props: ['cuit'],
  directives: {mask},
  components: {
    vSelect,
    VueGoogleAutocomplete,
    NumberInput,
    vuetagger,
    uploader
    // typeahead
    // GoogleAutocomplete
  },
  data () {
    return {
      originMarkerImage: require(`@/assets/img/icon/pin-fill.svg`),
      destinationMarkerImage: require(`@/assets/img/icon/placeholder-filled-point.svg`),
      current_fs: null,
      next_fs: null,
      previous_fs: null,
      left: null,
      opacity: null,
      scale: null,
      animating: null,
      email_tags: [],
      clientGeolocation: {
        latitude: null,
        longitude: null
      },
      markers: [],
      denominaciones: null,
      activeFleteIndex: 0,
      flete: {
        int: {
          type_incoterm_id: null, 
          border_crossing: null, 
          commodity_type:null
        },
        origin: {
          type_address: null,
          terminal: null,
          deposit: null,
          country_id: null,
          country_name: null,
          state_id: null,
          state_name: null,
          location: null,
          neighborhood: null,
          zipcode: null,
          street: null,
          number: null,
          comment: '',
          formatted_address: null,
          googlePlacesObject: null
        },
        dest: {
          type_address: null,
          terminal: null,
          deposit: null,
          country_id: null,
          country_name: null,
          state_id: null,
          state_name: null,
          location: null,
          neighborhood: null,
          zipcode: null,
          street: null,
          number: null,
          comment: '',
          formatted_address: null,
          googlePlacesObject: null
        },
        looseload: {
          weight: null,
          volume: null,
          type_cargo_id: null,
          hour_service: null,
          is_oversized: null,
          packages: []
        },
        container: {
          code: null,
          type_container_id: null,
          type_cargo_id: null,
          weight: null,
          is_oversized: null,
          retirement_date: null,
          comment: null
        },
        common: {
          has_assurance: null,
          has_custody: null,
          comment: '',
          watchers: []
        },
        extra_field: {
          retirement_date: null,
          time: null
        }
      },     
      package: {
        type_package_id: null,
        package_other: null,
        quantity: null,
        id_package: null,
        comment: null
      },
      payload: {
        tp_1: null,
        tp_2: null,
        tp_3: null,
        fletes: [],
      }
    }
  },
  beforeMount () {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
      let crd = pos.coords
      this.clientGeolocation.latitude = crd.latitude
      this.clientGeolocation.longitude = crd.longitude
      console.log('Your current position is:')
      console.log('Latitude : ' + crd.latitude)
      console.log('Longitude: ' + crd.longitude)
      console.log('More or less ' + crd.accuracy + ' meters.')
      }, (err) => {
      console.warn('ERROR(' + err.code + '): ' + err.message)
      this.clientGeolocation.latitude = -34.70408699999999
      this.clientGeolocation.longitude = -58.39200199999999
      }, {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    })

  },
  created () {
    this.denominaciones = denominaciones // Imoportar Denominaciones
    let flete = Object.assign({}, this.flete) // Crea el primer flete del Payload
    this.payload.fletes.push(flete)
 
    // let google = window.google
    // console.log(google)
    // this.autocomplete = new window.google.maps.places.Autocomplete(
    //   (this.$refs.autocomplete),
    //   {types: ['geocode']}
    // )
  },
  computed: {
    operacion () {
      let op = `${this.denominaciones[this.payload.tp_1]} ${this.denominaciones[this.payload.tp_2]} ${this.denominaciones[this.payload.tp_3]}`
      // Importacion \ Origen Terminal
      op+= this.payload.tp_1 === '6' && this.payload.fletes[this.activeFleteIndex].origin.type_address === '58' ? ` » ${this.denominaciones.terminales[this.payload.fletes[this.activeFleteIndex].origin.terminal]}` : ''
      // Importacion \ Deposito Fiscal
      op+= this.payload.tp_1 === '6' && this.payload.fletes[this.activeFleteIndex].origin.type_address === '59' ? ` » ${this.denominaciones.depositos[this.payload.fletes[this.activeFleteIndex].origin.deposit]}` : ''
      // Importacion \ Otro
      op+= this.payload.tp_1 === '6' && this.payload.fletes[this.activeFleteIndex].origin.type_address === 'other' ? ` » ${this.payload.fletes[this.activeFleteIndex].origin.street}` : ''

      return op
    }
  },
  methods: {
    updateTags (tags) {
      console.log(tags)
    },
    looseloadAddPackage () {
      let self = this
      let promise = new Promise((resolve, reject) => {
        setTimeout(() => {
          let pckg = Object.assign({}, self.package)
          self.payload.fletes[self.activeFleteIndex].looseload.packages.push(pckg)
          resolve(self.payload.fletes[self.activeFleteIndex].looseload.packages.length)
        }, 50)
      })
      promise.then((success) => {
        let index = parseInt(self.payload.fletes[self.activeFleteIndex].looseload.packages.length) - 1// Decrementa ya que el for pasa el idx en el Array
        self.$scrollInto(`looseload_package_${index}`)
      })
    },
    looseloadRemovePackage (index) {
      // console.log(index)
      if (confirm("Remover Bulto?")) {
        let i = parseInt(index)
        this.payload.fletes[this.activeFleteIndex].looseload.packages.splice(i, 1)
      }
    },
    setAddress (addressData, placeResultData, id) {
      console.log(id)
      if (id ===  'direccion_origen') {
        this.setOriginAddress(addressData, placeResultData, id)
      } else if (id === 'direccion_destino') {
        this.setDestinationAddress(addressData, placeResultData, id)
      }
    },
    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    setOriginAddress (addressData, placeResultData, id) {
      console.log(addressData)
      console.log(placeResultData)
      console.log(id)
      try {
        this.payload.fletes[this.activeFleteIndex].origin.country_id = null,
        this.payload.fletes[this.activeFleteIndex].origin.country_name = placeResultData.address_components[5].long_name,
        this.payload.fletes[this.activeFleteIndex].origin.state_id = null,
        this.payload.fletes[this.activeFleteIndex].origin.state_name = placeResultData.address_components[4].long_name,
        this.payload.fletes[this.activeFleteIndex].origin.location = null,
        this.payload.fletes[this.activeFleteIndex].origin.neighborhood = placeResultData.address_components[2].long_name,
        this.payload.fletes[this.activeFleteIndex].origin.zipcode = placeResultData.address_components[6].long_name,
        this.payload.fletes[this.activeFleteIndex].origin.street = placeResultData.address_components[1].long_name,
        this.payload.fletes[this.activeFleteIndex].origin.number = placeResultData.address_components[0].long_name
        this.payload.fletes[this.activeFleteIndex].origin.googlePlacesObject = {addressData, placeResultData}
        let originMarker = {}
        let myLatlng = new window.google.maps.LatLng(parseFloat(addressData.latitude),parseFloat(addressData.longitude))
        originMarker.coordinate = myLatlng
        originMarker.image = this.originMarkerImage        
        this.markers.push(originMarker)
      } catch (e) {
        console.warn(e.message)
      }
    },
    setDestinationAddress (addressData, placeResultData, id) {
      console.log(addressData)
      console.log(placeResultData)
      console.log(id)
      try {
        this.payload.fletes[this.activeFleteIndex].dest.country_id = null,
        this.payload.fletes[this.activeFleteIndex].dest.country_name = placeResultData.address_components[5].long_name,
        this.payload.fletes[this.activeFleteIndex].dest.state_id = null,
        this.payload.fletes[this.activeFleteIndex].dest.state_name = placeResultData.address_components[4].long_name,
        this.payload.fletes[this.activeFleteIndex].dest.location = null,
        this.payload.fletes[this.activeFleteIndex].dest.neighborhood = placeResultData.address_components[2].long_name,
        this.payload.fletes[this.activeFleteIndex].dest.zipcode = placeResultData.address_components[6].long_name,
        this.payload.fletes[this.activeFleteIndex].dest.street = placeResultData.address_components[1].long_name,
        this.payload.fletes[this.activeFleteIndex].dest.number = placeResultData.address_components[0].long_name
        this.payload.fletes[this.activeFleteIndex].dest.googlePlacesObject = {addressData, placeResultData}
        let destinationMarker = {}
        let myLatlng = new window.google.maps.LatLng(parseFloat(addressData.latitude),parseFloat(addressData.longitude))
        destinationMarker.coordinate = myLatlng
        destinationMarker.image = this.destinationMarkerImage
        this.markers.push(destinationMarker)
      } catch (e) {
        console.warn(e.message)
      }
    },
    addFlete () {
      if (this.payload.fletes.length > 1) {
        let flete = Object.assign({}, this.flete)
        this.payload.fletes.push(flete)
        this.activeFleteIndex = --this.payload.fletes.length
      }
    },
    submit () {
      let self = this
      axios.post("api/email.php", {
        payload: this.payload
      })
        .then(response => {
          // responseJson = JSON.parse(response)
          this.$scrollInto('notificaciones')
          $(".notification-success").html('Se envió el formulario con éxito').fadeIn()
          $('.form-process').fadeOut()
          setTimeout(() => {
            $(".notification-success").fadeOut()
          }, 5000)
 
        })
        .catch(e => {
          // alert(e.message)
          this.$scrollInto('notificaciones')
          $(".notification-error").fadeIn();
          setTimeout(() => {
            $(".notification-error").fadeOut()
          }, 5000)
        })
    },
    prev (ev) {
      this.animating = true
      this.current_fs = $(ev.target).parent()
      this.previous_fs = $(ev.target).parent().prev()

      // de-activate current step on progressbar
      $('#progressbar li').eq($('fieldset').index(this.current_fs)).removeClass('active')
      this.previous_fs.show()
      let self = this
      this.current_fs.animate({ opacity: 0 }, {
        step: (now, mx) => {
          self.scale = 0.8 + (1 - now) * 0.2
          self.left = ((1 - now) * 50) + '%'
          self.opacity = 1 - now
          self.current_fs.css({ 'left': self.left })
          self.previous_fs.css({ 'transform': 'scale(' + self.scale + ')', 'opacity': self.opacity })
        },
        duration: 800,
        complete: () => {
          self.current_fs.hide()
          self.animating = false
        },
        // this comes from the custom easing plugin
        easing: 'easeInOutBack'
      })
    },
    next (ev) {
      this.animating = true
      this.current_fs = $(ev.target).parent()
      this.next_fs = $(ev.target).parent().next()

      if ($(ev.target).attr('id') === 'agregarFlete') {
        let tipoOperacion = $("input[name='paso1:tipoOperacion']:checked").val()
        let tipoCarga = $("input[name='paso1:tipoCarga']:checked").val()

        switch (tipoOperacion) {
          case 'importacion':
            if (tipoCarga === 'cargaSuelta') {
              // cargaSuelta
            } else {
              // container
            }
            break
          case 'exportacion':
            break
          case 'traslado':
            break
        }
      } else {
        $('#progressbar li').eq($('fieldset').index(this.next_fs)).addClass('active')
      }
      this.next_fs.show()
      // hide the current fieldset with style
      let self = this
      this.current_fs.animate({ opacity: 0 }, {
        step: (now, mx) => {
          self.scale = 1 - (1 - now) * 0.2
          self.left = (now * 50) + '%'
          self.opacity = 1 - now
          self.current_fs.css({
            'transform': 'scale(' + self.scale + ')',
            'position': 'absolute'
          })
          self.next_fs.css({ 'left': self.left, 'opacity': self.opacity })
        },
        duration: 800,
        complete: () => {
          self.current_fs.hide()
          self.animating = false
        },
        easing: 'easeInOutBack' // this comes from the custom easing plugin
      })
      this.$scrollInto('top')
    }
  }
}
</script>

<style> 
@import '../assets/css/estilo-form.css';

.row {
  margin: 1em -15px 1em -15px;
}
.x_content {
  margin-top: 3em;
  margin-bottom: 3em;
}
.form-control, .vuetagger-input {
  font-size: 16px;
  border: none;
  border-bottom: 1px solid #cccccc;
  border-radius:0!important;
  -webkit-box-shadow: none!important;
  box-shadow:none!important;
  padding:7px 5px 7px 27px!important;
}
.vuetagger-input {
    background: url(../assets/img/icon/email.svg) no-repeat center left !important;
    background-size: 18px 18px !important;
    background-position: 0px !important;
}

.form-group label {
  float: left;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight:300;
  text-transform:uppercase;
  margin-bottom: 10px;
}
.vuetagger {
  display: table;
  border: none!important;
  padding: 0!important;
  width: 100%;
}
.vuetagger-list {
    text-align: left;
}
.vuetagger-tag {
  font-size: 14px;
  border-radius: 10px;
}
.notification-error {
color: #3d1811;
background-color: #ffa899;
border-color: #ff401e;
}
.notification-success {
color: #0c310c;
background-color: #74dd74;
border-color: #2aac2a;
}
.notification {
position: relative;
padding:1rem 1rem;
border: 0.0625rem solid transparent;
border-radius: 0.25rem;
font-size: 12px;
line-height: 1.5rem;
color: #2e2e2e;
color:#000;
font-size:15px;
font-family: 'Avenir Next';
font-weight: normal;
font-style: normal;	
}

</style>



// WEBPACK FOOTER //
// src/components/MultiStepForm.vue